import React from 'react';
import { FincluOperationDeliberation } from '@/types/FincluOperationStatus';
import { FincluStatusBadge } from './FincluStatusBadge';
import { useTranslations } from 'use-intl';
import { formatDistanceToNow } from 'date-fns';
import { es, enUS } from 'date-fns/locale';
import { getLanguageFromPath } from '@/utils/utils';

interface FincluDeliberationHistoryProps {
	history: FincluOperationDeliberation[];
}

export const FincluDeliberationHistory: React.FC<FincluDeliberationHistoryProps> = ({
	history
}) => {
	const t = useTranslations('SupportClients');
	const language = getLanguageFromPath(window.location.pathname);
	const locale = language === 'es' ? es : enUS;

	if (!history || history.length === 0) {
		return <div className="text-center text-gray-500 py-8">{t('NoDeliberationHistory')}</div>;
	}

	return (
		<div className="space-y-4">
			{history.map((deliberation, index) => (
				<div key={index} className="border border-gray-200 rounded-xl p-5 bg-gray-50 shadow-sm">
					<div className="flex items-center justify-between mb-4">
						<FincluStatusBadge status={deliberation.status} size="sm" />
						<span className="text-xs text-gray-400 font-medium">
							{formatDistanceToNow(new Date(deliberation.transitioned_at), {
								addSuffix: true,
								locale
							})}
						</span>
					</div>
					<div className="bg-white rounded-lg p-4 mb-4 border border-gray-100">
						<p className="text-sm text-gray-700 whitespace-pre-wrap leading-relaxed">
							{deliberation.deliberation_message}
						</p>
					</div>
					<div className="text-xs text-gray-400 pt-2 border-t border-gray-200">
						{t('Operator')}:{' '}
						<span className="font-medium text-gray-600">
							{deliberation.operator_email || deliberation.operator_id}
						</span>
					</div>
				</div>
			))}
		</div>
	);
};
